import Comps from "./companies.json";

export type Company = {
  CompanyID: number;
  Ticker: string;
  CompanyName: string;
  TickerCountry: string;
  "Bloomberg Ticker": string;
};

export const Companies: Company[] = Comps;

export const getCompany = (ticker: string): Company | undefined => {
  return Companies.find((c) => c.TickerCountry === ticker);
};

export const getBloombergTickers = (): string[] => {
  const tickers = Companies.map((c) => {
    const ticker = c["Bloomberg Ticker"];
    if (ticker) {
      return ticker;
    }
  });
  return tickers as string[];
};
